import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import { motion } from "framer-motion";
import headerImg from "../assets/img/header-img.svg";

const STATS = [
    { value: "10+",         label: "Projects Delivered" },
    { value: "5+",          label: "Happy Clients" },
    { value: "Full Stack",  label: "Dev + Marketing" },
];

const ROLES = [
    "Web Developer",
    "SEO Specialist",
    "Digital Marketer",
    "Tech Consultant",
];

export const Banner = () => {
    const [loopNum, setLoopNum]       = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText]             = useState('');
    const [delta, setDelta]           = useState(300 - Math.random() * 100);
    const period = 2000;

    useEffect(() => {
        let ticker = setInterval(() => tick(), delta);
        return () => clearInterval(ticker);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    const tick = () => {
        const i        = loopNum % ROLES.length;
        const fullText = ROLES[i];
        const updated  = isDeleting
            ? fullText.substring(0, text.length - 1)
            : fullText.substring(0, text.length + 1);
        setText(updated);
        if (isDeleting) { setDelta(p => p / 2); }
        if (!isDeleting && updated === fullText) { setIsDeleting(true); setDelta(period); }
        else if (isDeleting && updated === '')   { setIsDeleting(false); setLoopNum(n => n + 1); setDelta(500); }
    };

    const fadeUp = {
        hidden:  { opacity: 0, y: 30 },
        visible: (i = 0) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.7, delay: i * 0.13, ease: [0.4, 0, 0.2, 1] },
        }),
    };

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    {/* ── Left: copy ── */}
                    <Col xs={12} md={6} xl={7}>
                        <motion.div initial="hidden" animate="visible">

                            <motion.span className="tagline" variants={fadeUp} custom={0}>
                                Available for global projects
                            </motion.span>

                            <motion.h1 variants={fadeUp} custom={1}>
                                Hi, I'm{" "}
                                <span className="name-highlight">Ayomikun</span>
                                <br />
                                <span className="wrap">{text}</span>
                            </motion.h1>

                            <motion.p className="hero-desc" variants={fadeUp} custom={2}>
                                I design and build high-performance digital products that drive measurable
                                business results — from custom web applications to data-driven SEO
                                and social media strategies that grow your brand online.
                            </motion.p>

                            {/* Stats */}
                            <motion.div className="banner-stats" variants={fadeUp} custom={3}>
                                {STATS.map((s, i) => (
                                    <div className="banner-stat" key={i}>
                                        <strong>{s.value}</strong>
                                        <span>{s.label}</span>
                                    </div>
                                ))}
                            </motion.div>

                            {/* CTAs */}
                            <motion.div className="banner-cta-wrap" variants={fadeUp} custom={4}>
                                <button
                                    className="banner-btn-primary"
                                    onClick={() =>
                                        document.getElementById('connect')
                                            ?.scrollIntoView({ behavior: 'smooth' })
                                    }
                                >
                                    Let's Connect <ArrowRightCircle size={17} />
                                </button>
                                <button
                                    className="banner-btn-secondary"
                                    onClick={() =>
                                        document.getElementById('project')
                                            ?.scrollIntoView({ behavior: 'smooth' })
                                    }
                                >
                                    View Projects
                                </button>
                            </motion.div>

                        </motion.div>
                    </Col>

                    {/* ── Right: illustration ── */}
                    <Col xs={12} md={6} xl={5}>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.88, y: 20 }}
                            animate={{ opacity: 1, scale: 1,    y: 0  }}
                            transition={{ duration: 1, delay: 0.35, ease: [0.4, 0, 0.2, 1] }}
                        >
                            <img src={headerImg} alt="Developer illustration" className="hero-img" />
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
